import axios from '@/axios/api.request'

export const workByUid = (from) => axios.request({
    url: 'office/check/byUid',
    data: from,
    method: 'post'
})

export const workDetailByUid = (from) => axios.request({
    url: 'office/check/detailByUid',
    data: from,
    method: 'post'
})